import axios from "axios";

import { DataSource } from "../../types/dataSource/dataSource";

export const getDataSource = async (sourceId: string): Promise<DataSource> => {
  const { data } = await axios.get(`/data-sources/${sourceId}`);
  return data;
};
